import { route as routeName } from "./name";
import { route as routePrice } from "./price";
import { route as routeSku } from "./sku";
import { Link, Outlet } from "react-router";
import { route as routeResume } from "./resume";
import { route as routeCategory } from "./category";
import { Button } from "@repo/ui/components/button";
import { urlHome } from "../../../urls";
import { ArrowLeft } from "lucide-react";

function Layout() {
  return (
    <div className="flex flex-col gap-4 flex-1 h-full items-center justify-center w-full">
      <Outlet />
      <Button className="w-full" variant="pos" size="4xl" asChild>
        <Link to={urlHome()} viewTransition>
          <ArrowLeft className="w-4 h-4" />
          Volver al inicio
        </Link>
      </Button>
    </div>
  );
}

export const route = {
  element: <Layout />,
  children: [routeName, routePrice, routeSku, routeResume, routeCategory],
};
